// Fetch the inbox conversation list (scoped by current filters)
export const getInboxConversations = (payload) => ({
  type: 'GET_INBOX_CONVERSATIONS',
  payload // { append } — filters are read from store
});

// Set the conversation list + total + connected channels
export const setInboxConversations = (payload) => ({
  type: 'SET_INBOX_CONVERSATIONS',
  payload // { conversations, total, connectedChannels, append }
});

// Update inbox filters (channel / account / status / search / paging)
export const setInboxFilters = (payload) => ({
  type: 'SET_INBOX_FILTERS',
  payload // partial filters object
});

// Loading flag for the conversation list
export const setInboxLoading = (payload) => ({
  type: 'SET_INBOX_LOADING',
  payload
});

// Fetch + set the global unread total (sidebar badge)
export const getInboxUnreadCount = () => ({
  type: 'GET_INBOX_UNREAD_COUNT'
});

export const setInboxUnreadTotal = (payload) => ({
  type: 'SET_INBOX_UNREAD_TOTAL',
  payload // number
});

// Mark a contact's inbound messages as read
export const markInboxRead = (contactId) => ({
  type: 'MARK_INBOX_READ',
  payload: contactId
});

// Optimistically clear a row's unread count
export const markInboxRowRead = (contactId) => ({
  type: 'MARK_INBOX_ROW_READ',
  payload: contactId
});

// Mark a contact's conversation unread (latest inbound message only)
export const markInboxUnread = (contactId) => ({
  type: 'MARK_INBOX_UNREAD',
  payload: contactId
});

// Optimistically set a row's unread count to 1
export const markInboxRowUnread = (contactId) => ({
  type: 'MARK_INBOX_ROW_UNREAD',
  payload: contactId
});

// Mark a single message unread from the thread (activityId), reconciling the contact's row
export const markInboxMessageUnread = (activityId, contactId) => ({
  type: 'MARK_INBOX_MESSAGE_UNREAD',
  payload: { activityId, contactId }
});

// Load the contact for the active conversation (dedicated slot — NOT SinglePage)
export const getInboxContact = (contactId) => ({
  type: 'GET_INBOX_CONTACT',
  payload: contactId
});

export const setInboxActiveContact = (payload) => ({
  type: 'SET_INBOX_ACTIVE_CONTACT',
  payload // contact object
});

export const setInboxContactLoading = (payload) => ({
  type: 'SET_INBOX_CONTACT_LOADING',
  payload
});

// Set the selected conversation id
export const setInboxActiveContactId = (payload) => ({
  type: 'SET_INBOX_ACTIVE_CONTACT_ID',
  payload
});
